import ListItem from 'antd/es/list/Item';

const {Meta: ListItemMeta} = ListItem
export default  ListItemMeta;
